export default __webpack_public_path__ + "static/media/O-106.103459d8.png";